import { External } from "components/icons/generated";
import TableCellLink from "ds/components/Table/Row/CellLink";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ModulePullRequestsTableRow } from "../../../gql";
import ModulePullRequestsTableGroupCell from "../../GroupCell";

const ModulePullRequestsTablePullRequestPrCell = ({
  item: pullRequest,
  ...cellProps
}: TableSimpleCellProps<ModulePullRequestsTableRow>) => {
  return (
    <ModulePullRequestsTableGroupCell item={pullRequest} {...cellProps}>
      <TableCellLink variant="primary" target="_blank" endIcon={External} href={pullRequest.url}>
        {`#${pullRequest.id}`}
      </TableCellLink>
    </ModulePullRequestsTableGroupCell>
  );
};

export default ModulePullRequestsTablePullRequestPrCell;
